export default class CloudMessaging {
	public static async requestPermissions() {}

	public static async getToken(): Promise<string | null> {
		return null
	}

	public static async registerTokenToDoorhub() {}
}
